import axios from "axios";

import { successHandling } from "../helpers/successHandling";

export const updateSingleDeviceVncTwoFactorAPI = async (
  t,
  deviceId,
  IsTwoFactorEnable,
  onClose
) => {
  await axios({
    url: `/api/v2/vnc/security/update-device-2fa`,
    method: "PUT",
    data: {
      device_id: deviceId,
      is_two_factor_enable: IsTwoFactorEnable
    }
  });

  const successfulText = IsTwoFactorEnable
    ? `${t("tasks.successfullyTurnOnTwoFactor")}`
    : `${t("tasks.successfullyTurnOffTwoFactor")}`;
  successHandling(t, successfulText);
  onClose();
  return true;
};
